// extracted by mini-css-extract-plugin
module.exports = {"heading":"Stores_heading___UDzx","stores":"Stores_stores___IDxh"};